import { api } from '@/boot/axios'

export async function fetchOrderAheadQueue (locationId) {
  const params = {}
  if (locationId != null) params.location_id = locationId
  const { data } = await api.get('/order-ahead/queue', { params })
  return data
}

export async function updateOrderAheadFulfillment (saleId, fulfillmentStatus) {
  const { data } = await api.patch(`/order-ahead/sales/${saleId}/fulfillment`, {
    fulfillment_status: fulfillmentStatus
  })
  return data
}
